export default [
    {
        name: 'name',
        title: 'Nom du client',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '30%'
    },
    {
        name: 'dueStatus',
        title: 'DUE',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '30%'
    },
    {
        name: 'actions',
        title: 'Actions',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '30%'
    }
];